import React from 'react';
import { AutocompleteData } from '../models/Site';
import './_IDNameDescriptionItemSelect.css';

type Props = {
  Value: any | null;
  Id: string;
  OnChange?: (value: any) => void;
  OnSelect?: (value: any) => void;
  OnBlur?: (value: any) => void;
  OnFocus?: () => void;
  ClassName: string;
  DataList: Array<AutocompleteData>;
  simulatorData?: any;
  Disabled?: boolean;
};

type State = {
  isOptionOpen: boolean;
  value: any | null;
};

export class Autocomplete2 extends React.Component<Props, State> {
  containerRef = React.createRef<HTMLDivElement>();

  constructor(props: Props) {
    super(props);
    this.state = {
      isOptionOpen: false,
      value: props.Value
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.Value !== this.props.Value) {
      this.setState({ value: this.props.Value });
    }
  }

  handleOutsideClick = (e: MouseEvent) => {
    if (
      this.containerRef.current &&
      !this.containerRef.current.contains(e.target as Node)
    ) {
      this.setState({ isOptionOpen: false });
    }
  };

  handleFocus = () => {
    this.setState({ isOptionOpen: true });
    this.props.OnFocus?.();
  };

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    this.setState({
      value,
      isOptionOpen: true
    });

    this.props.OnChange?.(value);
  };

  handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    this.props.OnBlur?.(e.target.value);
  };

  handleSelect = (item: any) => {
    const value = item.val ?? item.value;

    this.setState({
      isOptionOpen: false
    });

    this.props.OnSelect?.(value);
  };

  handleDelete = () => {
    this.setState({
      value: '',
      isOptionOpen: false
    });

    this.props.OnChange?.('');
    this.props.OnSelect?.('');
  };

  render() {
    const { DataList, Id, simulatorData, Disabled } = this.props;
    const { isOptionOpen, value } = this.state;

    return (
      <div className="autocompleteDiv" ref={this.containerRef}>
        <input
          id={Id}
          type="text"
          value={value ?? ''}
          autoComplete="off"
          disabled={!!simulatorData || Disabled}
          onFocus={this.handleFocus}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />

        {/* delete icon */}
        <div
          className={
            !value || value.length === 0
              ? 'hide'
              : 'deleteIcon'
          }
          onClick={this.handleDelete}
        />

        {/* options */}
        <div className={isOptionOpen ? 'autocompleteList' : 'hide'}>
          {DataList?.map((item: any, index: number) => (
            <div
              key={index}
              className="autocompleteItem"
              onClick={() => this.handleSelect(item)}
            >
              {item.label ?? item.text}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
